// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* mobile first styles */

footer.main-footer {
  --page-padding: var(--page-padding-mobile);
  --page-delta-padding: var(--page-delta-padding-mobile);

  display: grid;
  grid-template-areas:
    "contactMe"
    "portrait";
  grid-template-columns: 1fr;
  grid-auto-rows: minmax(0, 1fr) minmax(0, 1fr);

  background: var(--footer-linear-gradient-mobile);
}

footer.main-footer .contact-me {
  grid-area: contactMe;
}

footer.main-footer .portrait {
  grid-area: portrait;

  width: 100%;

  /* make the height 0 to not affect the layout (row height), 
  and force min-height to100% to take the row height
  see: https://stackoverflow.com/questions/63726048/prevent-image-from-being-used-to-calculate-grid-row-height */
  height: 0;
  min-height: 100%;

  object-fit: cover;
}

/* mobile, horizontal */
@media only screen and (max-height: 550px) and (orientation: landscape) {
  footer.main-footer {
    grid-template-areas: "contactMe portrait";
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: minmax(0, 1fr);

    background: var(--footer-linear-gradient);
  }
}

/* tablet or larger */
@media only screen and (min-width: 767px) and (min-height: 551px) {
  footer.main-footer {
    --page-padding: var(--page-padding-tablet);

    grid-template-areas: "contactMe portrait";
    grid-template-columns: 0.6fr 0.4fr;
    grid-auto-rows: minmax(0, 1fr);

    height: min-content;
    padding: var(--page-padding);

    background: var(--footer-linear-gradient);
  }
}

/* desktop or larger */
@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {
  footer.main-footer {
    --page-padding: var(--page-padding-desktop);

    grid-template-columns: 0.4fr 0.6fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/footer.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,0CAA0C;EAC1C,sDAAsD;;EAEtD,aAAa;EACb;;cAEY;EACZ,0BAA0B;EAC1B,6CAA6C;;EAE7C,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;;EAEnB,WAAW;;EAEX;;gHAE8G;EAC9G,SAAS;EACT,gBAAgB;;EAEhB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE;IACE,yCAAyC;IACzC,8BAA8B;IAC9B,8BAA8B;;IAE9B,yCAAyC;EAC3C;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,0CAA0C;;IAE1C,yCAAyC;IACzC,kCAAkC;IAClC,8BAA8B;;IAE9B,mBAAmB;IACnB,4BAA4B;;IAE5B,yCAAyC;EAC3C;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,2CAA2C;;IAE3C,kCAAkC;EACpC;AACF","sourcesContent":["/* mobile first styles */\r\n\r\nfooter.main-footer {\r\n  --page-padding: var(--page-padding-mobile);\r\n  --page-delta-padding: var(--page-delta-padding-mobile);\r\n\r\n  display: grid;\r\n  grid-template-areas:\r\n    \"contactMe\"\r\n    \"portrait\";\r\n  grid-template-columns: 1fr;\r\n  grid-auto-rows: minmax(0, 1fr) minmax(0, 1fr);\r\n\r\n  background: var(--footer-linear-gradient-mobile);\r\n}\r\n\r\nfooter.main-footer .contact-me {\r\n  grid-area: contactMe;\r\n}\r\n\r\nfooter.main-footer .portrait {\r\n  grid-area: portrait;\r\n\r\n  width: 100%;\r\n\r\n  /* make the height 0 to not affect the layout (row height), \r\n  and force min-height to100% to take the row height\r\n  see: https://stackoverflow.com/questions/63726048/prevent-image-from-being-used-to-calculate-grid-row-height */\r\n  height: 0;\r\n  min-height: 100%;\r\n\r\n  object-fit: cover;\r\n}\r\n\r\n/* mobile, horizontal */\r\n@media only screen and (max-height: 550px) and (orientation: landscape) {\r\n  footer.main-footer {\r\n    grid-template-areas: \"contactMe portrait\";\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-auto-rows: minmax(0, 1fr);\r\n\r\n    background: var(--footer-linear-gradient);\r\n  }\r\n}\r\n\r\n/* tablet or larger */\r\n@media only screen and (min-width: 767px) and (min-height: 551px) {\r\n  footer.main-footer {\r\n    --page-padding: var(--page-padding-tablet);\r\n\r\n    grid-template-areas: \"contactMe portrait\";\r\n    grid-template-columns: 0.6fr 0.4fr;\r\n    grid-auto-rows: minmax(0, 1fr);\r\n\r\n    height: min-content;\r\n    padding: var(--page-padding);\r\n\r\n    background: var(--footer-linear-gradient);\r\n  }\r\n}\r\n\r\n/* desktop or larger */\r\n@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {\r\n  footer.main-footer {\r\n    --page-padding: var(--page-padding-desktop);\r\n\r\n    grid-template-columns: 0.4fr 0.6fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
